import { loginComponents } from './login';
import { formComponents } from './forms';
var components = Object.assign({}, loginComponents, formComponents);
export { components };
